import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Task } from 'src/models/task.model';

@Component({
    selector: 'app-tasklist',
    templateUrl: './tasklist.component.html',
    styleUrls: ['./tasklist.component.scss'],
    standalone: false
})
export class TasklistComponent {
  @Input() public tasks: Task[] = [];
  @Input() public isLoading = false;
  @Input() public checkmarks = false;
  @Input() public viewCreationDate = false;
  @Input() showPriorities: boolean = false;

  /** Whether to show the show/production name on each task */
  @Input() showShowName: boolean = false;

  /** Whether this component is embedded in a master-detail layout */
  @Input() embedded: boolean = false;

  /** Currently selected task ID (for highlighting in embedded mode) */
  @Input() selectedId: number | null = null;

  @Output() public taskStatusChanged: EventEmitter<any> = new EventEmitter<any>();

  /** Emits when a task is selected in embedded mode */
  @Output() taskSelected = new EventEmitter<number>();

  public emitChange() {
    this.taskStatusChanged.emit();
  }

  public onTaskSelect(taskId: number): void {
    this.taskSelected.emit(taskId);
  }
}
